import { render, staticRenderFns } from "./ReportCreateForm.vue?vue&type=template&id=2be074b6&scoped=true"
import script from "./ReportCreateForm.vue?vue&type=script&lang=js"
export * from "./ReportCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be074b6",
  null
  
)

export default component.exports